import {Routes} from '@angular/router';
import { LandingPage_PATH, AboutPage_PATH, BeerDetailPage_PATH, AddBeerFormPage_PATH, AddBreweryFormPage_PATH, AnalysesPage_PATH, ApploginPage_PATH, AuthPage_PATH, ContactPage_PATH, FaqPage_PATH, HomePage_PATH, SearchPage_PATH, SearchBreweryPage_PATH, SelectorPopoverPage_PATH, TabsPage_PATH, VenueSelectionPopoverPage_PATH, WebloginPage_PATH, WishlistPage_PATH } from './app-constants';
import { HomePage } from '../pages/home/home';
import { WishlistPage } from '../pages/wishlist/wishlist';
import { AnalysesPage } from '../pages/analyses/analyses';
import { FaqPage } from '../pages/faq/faq';
import { AddBeerFormPage } from '../pages/add-beer-form/add-beer-form';
import { AddBreweryFormPage } from '../pages/add-brewery-form/add-brewery-form';
import { BeerDetailPage } from '../pages/beer-detail/beer-detail';
import { ContactPage } from '../pages/contact/contact';
import { SearchPage } from '../pages/search/search';
import { SearchBreweryPage } from '../pages/search-brewery/search-brewery';
import { SelectorPopoverPage } from '../pages/selector-popover/selector-popover';
import { TabsPage } from '../pages/tabs/tabs';
import { VenueSelectionPopoverPage } from '../pages/venue-selection-popover/venue-selection-popover';
import { AuthPage } from '../pages/auth/auth';
import { LandingPage } from '../pages/landing/landing';
import { ApploginPage } from '../pages/applogin/applogin';
import { WebloginPage } from '../pages/weblogin/weblogin';
import { AboutPage } from '../pages/about/about';

export const routes: Routes = [ 
    // Ensure you import Routes from '@angular/router'; 
    { path: AboutPage_PATH, component: AboutPage },
    { path: BeerDetailPage_PATH, component: BeerDetailPage, data: { forceRefresh: true } },
    { path: AddBeerFormPage_PATH, component: AddBeerFormPage },
    { path: AddBreweryFormPage_PATH, component: AddBreweryFormPage },
    { path: AnalysesPage_PATH, component: AnalysesPage },
    { path: ApploginPage_PATH, component: ApploginPage },
    { path: AuthPage_PATH, component: AuthPage },
    { path: ContactPage_PATH, component: ContactPage },
    { path: FaqPage_PATH, component: FaqPage },
    { path: HomePage_PATH, component: HomePage },
    { path: LandingPage_PATH, component: LandingPage },
//        loadChildren: () => import('../pages/landing/landing.module').then( m => m.LandingPageModule) },
    { path: SearchPage_PATH, component: SearchPage },
    { path: SearchBreweryPage_PATH, component: SearchBreweryPage },
    { path: SelectorPopoverPage_PATH, component: SelectorPopoverPage },
    { path: TabsPage_PATH, component: TabsPage },
    { path: VenueSelectionPopoverPage_PATH, component: VenueSelectionPopoverPage },
    { path: WebloginPage_PATH, component: WebloginPage },
    { path: WishlistPage_PATH, component: WishlistPage },
    { path: '', redirectTo: LandingPage_PATH, pathMatch: 'full' } // Set a default route
];
